/* eslint-disable camelcase */
import '../../../kohandlers/writeonlyvalue';
import SupplementViewModel from './viewmodels/supplementviewmodel';
import elementIntersectionObserver from '../../../dom/elementintersectionobserver';
import imageManager from './imagemanager';
import ko from 'knockout';
import { lazybvshow, initializeBVReviewClick } from '../shared/lazybvshow';
import observeImages from '../../../lazyloadimages';
import { productsOnPage } from '../../../vendor/googletagmanager/events';
import { getUserLocation } from '../../../vendor/dynamicyield/dynamicyield';
import handleRestrictions from '../shared/ordercontrolrestrictions';
import { restrictions } from './ordercontrolrestrictions';
import waitForElement from '../../../dom/waitforelement.js';
import hideBVQAButton from '../shared/hidebvqabutton.js';
import spViewItem from '../../../vendor/googletagmanager/spevents/spviewitem.js';

const cookie = smartPak.cdProfileCookie,
    config = {
        discipline: cookie && cookie.PrimaryDiscipline ? cookie.PrimaryDiscipline.toLowerCase() : '',
        isPerksEligible: smartPak.smartPrimeCookie.PerksEligible === 'True',
        coliCareForPouchesEnabled: smartPak.pageData.coliCareForPouchesEnabled
    },
    $container = document.getElementById('productClassCon'),
    PREMADE = {
        starter: 31331,
        nutritionEssential: 32083,
        foundation: 31332,
        seniorPerformance: 31333,
        performance: 31334,
        seniorFoundation: 31335,
        lessStress: 31336
    };

let productClassViewModel;

if (window.productClassData) {
    window.productClassData.url = location.pathname;
    smartPak.pageData.productId = window.productClassData.id;

    productsOnPage([{
        name: window.productClassData.name.trim(),
        productClassId: window.productClassData.id,
        itemId: window.productClassData.itemNumber
    }]);

    productClassViewModel = smartPak.productClassViewModel = new SupplementViewModel(window.productClassData, config);

    getUserLocation().then(geoFields => {
        productClassViewModel.userDetectedLocation(geoFields);
    });

    imageManager.init(productClassViewModel);
    ko.applyBindings(productClassViewModel, $container);

    requestAnimationFrame(() => {
        if (
            [
                PREMADE.starter,
                PREMADE.nutritionEssential,
                PREMADE.foundation,
                PREMADE.seniorPerformance,
                PREMADE.performance,
                PREMADE.seniorFoundation,
                PREMADE.lessStress
            ].includes(window.productClassData.itemNumber)
        ) {
            switch (window.productClassData.itemNumber) {
                case PREMADE.starter:
                    import('./premade/starterpak').then(({ default: premade }) => premade());
                    break;

                case PREMADE.nutritionEssential:
                    import('./premade/nutritionessentialpak').then(({ default: premade }) => premade());
                    break;

                case PREMADE.foundation:
                    import('./premade/foundationpak').then(({ default: premade }) => premade());
                    break;

                case PREMADE.seniorPerformance:
                    import('./premade/seniorperformancepak').then(({ default: premade }) => premade());
                    break;

                case PREMADE.performance:
                    import('./premade/performancepak').then(({ default: premade }) => premade());
                    break;

                case PREMADE.seniorFoundation:
                    import('./premade/seniorfoundationpak.js').then(({ default: premade }) => premade());
                    break;

                case PREMADE.lessStress:
                    import('./premade/lessstresspak').then(({ default: premade }) => premade());
                    break;

                default:
                    break;
            }
        }
    });

    handleRestrictions(productClassViewModel, restrictions);

    const $content = document.querySelector('.content-sections'),
        observe = elementIntersectionObserver();
    const reviewStars = document.getElementById('productInfoStars');

    if ($content) {
        observe($content, () => {
            import('./contentmanager').then(({ default: contentManager }) => contentManager.init($content));
        });
    }

    spViewItem({
        item_name: productClassViewModel.name(),
        item_id: productClassViewModel.itemNumber(),
        item_brand: productClassViewModel.manufacturer(),
        item_parent_reporting_category: productClassViewModel.parentReportingCategory(),
        item_child_reporting_category: productClassViewModel.childReportingCategory(),
        price: productClassViewModel.selectedProduct() ? productClassViewModel.selectedProduct().cost() : productClassViewModel.products()[0]?.price?.current(),
    }); 

    waitForElement('[data-lazy-bv-show="questions"]', $element => hideBVQAButton($element));

    observeImages($container);
    import('./ordercontrol').then(({ default: orderControl }) => orderControl.init(productClassViewModel, false));
    lazybvshow();
    initializeBVReviewClick(reviewStars);
}
